import React, { useState } from "react";
import { Container, Form, Row, Col } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import "./UnifiedFormStyles.css";
import AppButton from "../../Components/MerchantButton";

function NotInterestedMayaSolution({ navigation, primaryDetails, setPrimaryDetails }) {
  const [isError, setIsError] = useState({
    not_interested_reason: false,
    pending_application: false,
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setPrimaryDetails(prev => ({ ...prev,
      [name]: value,
    }));
    
    if (isError[name]) {
      setIsError({
        ...isError,
        [name]: false,
      });
    }
  };

  const validateForm = () => {
    const errors = {
      not_interested_reason: !primaryDetails.not_interested_reason || primaryDetails.not_interested_reason.trim() === "",
      pending_application: !primaryDetails.pending_application, 
      pending_solution: primaryDetails.pending_application === "yes" && !primaryDetails.pending_solution,
    };

    setIsError(errors);

    const hasErrors = Object.values(errors).some(error => error);
    if (hasErrors) {
      toast.error("Please fill in all required fields", {
        autoClose: 3000,
        hideProgressBar: true,
        theme: "colored",
      });
      return false;
    }
    return true;
  };
  const isFormValid = () => {
    if (!primaryDetails.not_interested_reason || primaryDetails.not_interested_reason.trim() === "") {
      return false;
    }
    if (!primaryDetails.pending_application) {
      return false;
    }
    if (primaryDetails.pending_application === "yes" && !primaryDetails.pending_solution) {
      return false;
    }
    return true;
  };
  const handleNext = () => {
    if (validateForm()) {
      navigation.go("terminal-availability");
    }
  };

  const handleBack = () => {
    if (navigation && navigation.previous) navigation.previous();
  };

  return (
    <div className="form-bg">
      <Container>
        <ToastContainer />
        <Row className="justify-content-md-center">
          {/* Form Content */}
          <Col md={8}>
              <div className="form-main-header">
                <h4 className="form-title">
                  NOT INTERESTED TO GET MAYA SOLUTION
                </h4>
                <p className="form-desc">
                  Please provide your reason for not being interested
                </p>
              </div>
              <div className="form-main">
              <div className="form-main-content">
                <Form className="form-form">
                  <Form.Group className="mb-4">
                    <Form.Label className="form-label">
                      If No, state the reason <span className="form-required">*</span>
                    </Form.Label>

                    <Form.Control
                      as="textarea"
                      rows={4}
                      name="not_interested_reason"
                      value={primaryDetails.not_interested_reason || ""}
                      onChange={handleInputChange}
                      placeholder="Short answer text"
                      className={`form-textarea ${isError.not_interested_reason ? 'form-input-error' : ''}`}
                    />

                    
                    {isError.not_interested_reason && (
                      <div className="form-error">
                        Please provide a reason
                      </div>
                    )}
                  </Form.Group>

                  <Form.Group className="mb-4">
                    <Form.Label className="form-label">
                      May pending application ng Maya Solution? <span className="form-required">*</span>
                    </Form.Label>
                    <div className="form-radio-group">
                      <div
                        className={`form-radio-item${primaryDetails.pending_application === "yes" ? " selected" : ""}`}
                      >
                        <div className="form-radio-flex">
                          <Form.Check
                            type="radio"
                            id="pending_application_yes"
                            name="pending_application"
                            value="yes"
                            checked={primaryDetails.pending_application === "yes"}
                            onChange={handleInputChange}
                            label="Yes"
                            className="form-radio"
                          />
                        </div>
                      </div>
                      <div
                        className={`form-radio-item${primaryDetails.pending_application === "no" ? " selected" : ""}`}
                      >
                        <div className="form-radio-flex">
                          <Form.Check
                            type="radio"
                            id="pending_application_no"
                            name="pending_application"
                            value="no"
                            checked={primaryDetails.pending_application === "no"}
                            onChange={handleInputChange}
                            label="No"
                            className="form-radio"
                          />
                        </div>
                      </div>
                    </div>
                    {isError.pending_application && (
                      <div className="form-error">
                        Please select an option
                      </div>
                    )}
                  </Form.Group>

                  {primaryDetails.pending_application === "yes" && (
                    <Form.Group className="mb-4">
                      <Form.Label className="form-label">
                        If Yes Anong Maya Solution? <span className="form-required">*</span>
                      </Form.Label>
                      <div className="form-radio-group">
                        <div
                          className={`form-radio-item${primaryDetails.pending_solution === "sqr" ? " selected" : ""}`}
                        >
                          <div className="form-radio-flex">
                            <Form.Check
                              type="radio"
                              id="pending_solution_sqr"
                              name="pending_solution"
                              value="sqr"
                              checked={primaryDetails.pending_solution === "sqr"}
                              onChange={handleInputChange}
                              label="SQR"
                              className="form-radio"
                            />
                          </div>
                        </div>
                        <div
                          className={`form-radio-item${primaryDetails.pending_solution === "terminal" ? " selected" : ""}`}
                        >
                          <div className="form-radio-flex">
                            <Form.Check
                              type="radio"
                              id="pending_solution_terminal"
                              name="pending_solution"
                              value="terminal"
                              checked={primaryDetails.pending_solution === "terminal"}
                              onChange={handleInputChange}
                              label="TERMINAL"
                              className="form-radio"
                            />
                          </div>
                        </div>
                        <div
                          className={`form-radio-item${primaryDetails.pending_solution === "both" ? " selected" : ""}`}
                        >
                          <div className="form-radio-flex">
                            <Form.Check
                              type="radio"
                              id="pending_solution_both"
                              name="pending_solution"
                              value="both"
                              checked={primaryDetails.pending_solution === "both"}
                              onChange={handleInputChange}
                              label="Both"
                              className="form-radio"
                            />
                          </div>
                        </div>
                      </div>
                      {isError.pending_solution && (
                        <div className="form-error">
                          Please select an option
                        </div>
                      )}
                    </Form.Group>
                  )}

              
                  <div className="form-btn-row">
                    <AppButton
                      onClick={handleBack}
                      variant="back"
                      className="form-btn variant-secondary"
                    >
                      ← Back
                    </AppButton>
                    <AppButton
                      onClick={handleNext}
                      variant="next"
                      className="form-btn variant-primary"
                      disabled={!isFormValid()}
                    >
                       Next →
                    </AppButton>
                  </div>
                </Form>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default NotInterestedMayaSolution;
